import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Pusher from 'pusher-js';
import config from '~/src/config';
import actionsOrder from '~/redux/order/actions';
import actionsBooking from '~/redux/booking/actions';
import actionsMessage from '~/redux/message/actions';

import Cookies from 'js-cookie';

window.pusherRunning = false;

function App(props) {
    const dispatch = useDispatch();
    const business = useSelector((state) => state.business);
    const user = useSelector((state) => state.user);

    const sess = Cookies.get('sess');

    useEffect(() => {
        if (business && business.info && window.pusherRunning === false) {
            window.pusherRunning = true;
            //console.log(12345);
            //console.log('HANDLER NOTIFICATION');
            //console.log(business.info.uuid);
            //console.log(user.uuid);
            //console.log(sess);

            const pusher = new Pusher(config.PUSHER_APP_KEY, {
                cluster: config.PUSHER_APP_CLUSTER,
                encrypted: true,
            });

            const channel = pusher.subscribe(business.info.uuid);

            channel.bind('reload-app', (data) => {
                console.log('reload-app');
                console.log(data);
                //dispatch(actionsOrder.fetchOrder());
            });

            channel.bind('reload-table', (data) => {
                console.log('reload-table');
                console.log(data);
                dispatch(actionsOrder.fetchOrder());
            });
        }
    }, [business]);

    useEffect(() => {
        if (user && user.uuid) {
            const pusherWebuser = new Pusher(config.PUSHER_APP_KEY, {
                cluster: config.PUSHER_APP_CLUSTER,
                encrypted: true,
            });

            const channelWebuser = pusherWebuser.subscribe(user.uuid);

            channelWebuser.bind('reload-webuser-order', (data) => {
                console.log('reload-webuser-order');
                console.log(data);
                dispatch(actionsOrder.fetchOrder());
            });

            channelWebuser.bind('reload-webuser-booking', (data) => {
                console.log('reload-webuser-booking');
                console.log(data);
                dispatch(actionsBooking.fetchBooking());
            });

            channelWebuser.bind('reload-webuser-conversation', (data) => {
                console.log('reload-webuser-conversation');
                console.log(data);
                dispatch(actionsMessage.fetchMessage());
            });
        }
    }, [user]);

    return false;
}

export default App;
